// extracted by mini-css-extract-plugin
export var fullWidth = "InvidooButton-module--fullWidth--03f1b";
export var hasNavIconEnd = "InvidooButton-module--hasNavIconEnd--f88c0";
export var iconEnd = "InvidooButton-module--iconEnd--47bb6";
export var iconStart = "InvidooButton-module--iconStart--b307d";
export var label = "InvidooButton-module--label--37fac";
export var navIconEnd = "InvidooButton-module--navIconEnd--2fb84";
export var navIconStart = "InvidooButton-module--navIconStart--2f3c5";
export var root = "InvidooButton-module--root--a6231";
export var sizeMedium = "InvidooButton-module--sizeMedium--c81ab";
export var sizeSmall = "InvidooButton-module--sizeSmall--f6d6d";
export var variantPrimary = "InvidooButton-module--variantPrimary--33b58";
export var variantSecondary = "InvidooButton-module--variantSecondary--7e14c";
export var variantText = "InvidooButton-module--variantText--52a9d";